import _ from '@lodash';
import { makeStyles } from '@material-ui/core/styles';
import { AgGridReact } from 'ag-grid-react';
import '../../../../styles/ag-custom.css';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const useStyles = makeStyles({
	layoutRoot: {},
	head: {
		position: "sticky",
		top: 0
	  },
	  root: {
		// minWidth: 275,
	  },
	  title: {
		fontSize: 14,
	  },
	  pos: {
		marginBottom: 12,
	  },
});

function ListView(props) {
    const classes = useStyles();
	// console.log(props.endUsersAccounts);
	return (
			
			// <FuseScrollbars className="flex-grow overflow-x-auto">
				<div className="ag-theme-alpine" style={{height: 400, width: "100%"}}>
                    <AgGridReact
						rowData={props.endUsersAccounts}
						theme='legacy'
						onRowClicked={e => { props.gotoDetailsPage(e.data.id) }}
						columnDefs={[
							...Object.keys(props.endUsersAccounts[0])
								.filter((header) => header != 'id')
								.map((header) => {
									return {
										field: header,
										sortable: true,
										filter: true,
										headerName: header.split('_').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')
									};
								}),
						]}
			 />
                </div>
			// </FuseScrollbars>
			
	);

}

export default ListView
